/**
 * Returns a string with a language-sensitive representation of the provided value.
 * @param {string|number} value - The value to format.
 * @param {number} [maximumFractionDigits=1] - The maximum number of fraction digits to use.
 * @param {number} [minimumFractionDigits=0] - The minimum number of fraction digits to use.
 * @param {string} [locale='nb-NO'] - The locale string (BCP 47 language tag) to be used for the formatting.
 */
export function currency(value, maximumFractionDigits = 1, minimumFractionDigits = 0, locale = 'nb-NO') {
	let float = Number(parseFloat(('' + value).replace(',', '.').replace(/[^0-9.-]/g, '')));

	if (!isFinite(float)) return '';
	return float.toLocaleString(locale, {
		maximumFractionDigits: isFinite(maximumFractionDigits) ? maximumFractionDigits : 1,
		minimumFractionDigits: isFinite(minimumFractionDigits) ? minimumFractionDigits : 0
	});
}

/**
 * Formats a string date to a date and formats it to : DD/MM/YYYY
 * @param {value} date
 */
export function dateFormatString(value) {
	if (value) {
		const date = new Date(value);
		return date.toLocaleDateString();
	}
}
